export default "__VITE_PUBLIC_ASSET__1a5bbb7f__"